module.exports = __webpack_public_path__ + "img/slider-img.2daaf54.jpg";